import { Box, TextField } from "@pav/pav-products-design-system";
import ManualEntryModalButtons from "./ManualEntryModalButtons";
import { Controller, useForm } from "react-hook-form";
import { faro } from "@grafana/faro-react";

export default function ManualEntryForm({ handleClose, onDataChanged }) {
  const {
    clearErrors,
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    criteriaMode: "all",
    defaultValues: {
      accountNumber: "",
      routingNumber: "",
    },
  });

  const onSubmit = async (data) => {
    clearErrors();
    await onDataChanged({
      routingNumber: data.routingNumber,
      accountNumber: data.accountNumber,
    });
    faro.api.pushEvent("Successully added bank manually");
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Box className="header">Manual Entry</Box>
        <Box
          className="subhead"
          sx={{
            marginBottom: "var(--spacing-md)",
          }}
        >
          My Bank Account Credentials
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--spacing-md)",
            marginBottom: "var(--spacing-2xl)",
          }}
        >
          <Controller
            name="accountNumber"
            rules={{
              pattern: {
                value: /^\d+$/,
                message: "Please enter only numbers.",
              },
              required: { value: true, message: "Account number is required." },
              minLength: {
                value: 4,
                message: "Must be at least 4 digits.",
              },
            }}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Account number"
                error={!!errors.accountNumber}
                errorText={errors.accountNumber?.message}
                autoComplete="off"
                required
              />
            )}
          />
          <Controller
            name="routingNumber"
            rules={{
              pattern: {
                value: /^\d+$/,
                message: "Please enter only numbers.",
              },
              required: { value: true, message: "Routing number is required." },
              minLength: {
                value: 8,
                message: "Must be at least 8 digits.",
              },
            }}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Routing number"
                error={!!errors.routingNumber}
                errorText={errors.routingNumber?.message}
                autoComplete="off"
                required
              />
            )}
          />
        </Box>
        <ManualEntryModalButtons handleClose={handleClose} isValid={isValid} />
      </form>
    </Box>
  );
}
